export type PageMetadataFormValues = {
  metaTitle: string;
  metaDescription: string;
};

function metadataString(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

const RESERVED_OPTION_KEYS = ["metaTitle", "metaDescription", "listInSidebar"];

export function pageOptionsToFormValues(options: Record<string, unknown> | null | undefined) {
  const { metaTitle, metaDescription } = options ?? {};
  const otherOptions = Object.fromEntries(
    Object.entries(options ?? {}).filter(([key]) => !RESERVED_OPTION_KEYS.includes(key)),
  );
  return {
    metaTitle: metadataString(metaTitle),
    metaDescription: metadataString(metaDescription),
    options: Object.keys(otherOptions).length ? JSON.stringify(otherOptions, null, 2) : "",
  };
}

export function pageOptionsFromFormValues(
  metadata: PageMetadataFormValues,
  rawOptions = "",
): Record<string, unknown> | null {
  let options: Record<string, unknown> = {};
  if (rawOptions.trim()) {
    let parsed: unknown;
    try {
      parsed = JSON.parse(rawOptions);
    } catch {
      throw new Error("Invalid JSON in options field");
    }
    if (parsed === null || typeof parsed !== "object" || Array.isArray(parsed)) {
      throw new Error("Options must be a JSON object");
    }
    options = { ...parsed };
  }
  for (const key of RESERVED_OPTION_KEYS) {
    delete options[key];
  }
  const metaTitle = metadataString(metadata.metaTitle);
  const metaDescription = metadataString(metadata.metaDescription);
  if (metaTitle) options.metaTitle = metaTitle;
  if (metaDescription) options.metaDescription = metaDescription;
  return Object.keys(options).length ? options : null;
}
